import client from "../client";

export const updateGdprByPubId = async (pub_id: number, event: number) => {
  const res = await client.post(`gdpr`, {
    pub_id: pub_id,
    event: event,
  });
  return res.data;
};
